import { Controller } from '@hotwired/stimulus'

export default class ReloadableFrameController extends Controller {
  static targets = ['frame'];

  connect() {
  }

  reload() {
    if (this.frameTarget.src) {
      this.frameTarget.reload();
    } else {
      this.frameTarget.src = this.frameTarget.dataset.src;
    }
  }
}
